export enum MutationTypes {
  CHANGE_CURRENT_STEP = 'changeCurrentStep',
  CHANGE_LOADING = 'changeLoading',
}
